export const privacyRadioData = [
  { label: "Public", value: 1 },
  { label: "Private", value: 2 },
  { label: "Private except for profiles I...", value: 3 },
];

export const privateExceptData = [
  { id: "privacy_for_interested_in", label: "Am interested in" },
  { id: "privacy_for_favorited", label: "Have favorited" },
  { id: "privacy_for_visited", label: "Have visited" },
];
